import { px2rem } from '../utils/helpers/style.js';

var colorSchemeNative = {
  active: {
    buttonBackgroundColor: 'primary',
    buttonBackgroundOpacity: 0.1,
    iconColor: 'primary',
    textColor: 'text.primary'
  },
  inactive: {
    buttonBackgroundColor: 'transparent',
    buttonBackgroundOpacity: 0,
    iconColor: 'primary',
    textColor: 'text.primary'
  },
  componentDisabled: {
    buttonBackgroundColor: 'transparent',
    buttonBackgroundOpacity: 0,
    iconColor: 'text.disabled',
    textColor: 'text.disabled'
  },
  buttonDisabled: {
    buttonBackgroundColor: 'button.disabled',
    buttonBackgroundOpacity: 1,
    iconColor: 'text.disabled',
    textColor: 'text.disabled'
  }
};
var sizingsNative = {
  xs: {
    height: 40,
    buttonSize: 28,
    borderRadius: 2,
    width: 104,
    padding: 4
  },
  s: {
    height: 48,
    buttonSize: 32,
    borderRadius: 2,
    width: 120,
    padding: 6
  },
  m: {
    height: 56,
    buttonSize: 40,
    borderRadius: 2,
    width: 144,
    padding: 6
  },
  l: {
    height: 64,
    buttonSize: 48,
    borderRadius: 2,
    width: 168,
    padding: 6
  }
};
var counterThemeNative = {
  color: 'primary',
  border: {
    color: 'border.inactive',
    width: 2
  },
  icon: {
    size: 24
  },
  fontSize: 'l',
  borderRadius: 4,
  sizings: sizingsNative,
  colorSchemes: colorSchemeNative,
  backgroundColor: 'background.primary'
};
var counterSizingsWeb = {
  xs: {
    buttonHeight: 28,
    containerWidth: px2rem(104),
    containerPadding: px2rem(4)
  },
  s: {
    buttonHeight: 32,
    containerWidth: px2rem(120),
    containerPadding: px2rem(6)
  },
  m: {
    buttonHeight: 40,
    containerWidth: px2rem(144),
    containerPadding: px2rem(6)
  },
  l: {
    buttonHeight: 48,
    containerWidth: px2rem(168),
    containerPadding: px2rem(6)
  }
};
var counterThemeWeb = {
  border: {
    width: px2rem(2),
    color: 'borders.inactive'
  },
  disabled: {
    textColor: 'text.disabled',
    buttonColor: 'background.primary'
  },
  sizings: counterSizingsWeb
};

export { colorSchemeNative, counterThemeNative, counterThemeWeb, sizingsNative };
